"use client";

// شبنم از همان ابتدای <head> دانلود شود، نه وقتی مرورگر به اولین متن می‌رسد (font-display: swap در global.css).
// React این <link> را به <head> می‌برد. از root layout (Server Component) نه preload() به HTML اولیه می‌رسید و نه
// <link> (دو بار در head می‌آمد)؛ از یک کامپوننت client فقط یک بار.
const FONT_FILES = ["/fonts/Shabnam-FD.woff2", "/fonts/Shabnam-Bold-FD.woff2"];

export default function FontPreload() {
  return FONT_FILES.map((href) => (
    <link key={href} rel="preload" href={href} as="font" type="font/woff2" crossOrigin="anonymous" />
  ));
}
